var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 475,
    viewBox: "0 0 1440 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M474.636 54.5716C367.943 67.9429 100.81 45.3835 -19.4199 32.4324L-18.683 77.4673L-12.6792 444.369C123.415 425.651 283.308 443.879 481.399 467.833C679.489 491.787 896.352 448.067 1080.52 431.042C1227.85 417.421 1474.57 438.781 1579.51 451.164L1572.91 47.8363C1529.02 65.3264 1341 49.2585 1131.65 12.1264C922.297 -25.0057 608.002 37.8575 474.636 54.5716Z",
    fill: "#00B9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector 1.7d17b9726d2bafe1e773ee6980e9e348.svg";
export { ForwardRef as ReactComponent };